import Container from "@mui/material/Container";
import { makeStyles } from "@mui/styles";

import isoImage from "./../../assets/images/certificate/iso.jpg";
import pciDssImage from "./../../assets/images/certificate/pci-dss.jpg";
import pspImage from "./../../assets/images/certificate/psp.jpg";



import { Typography } from "@mui/material";

const useStyle = makeStyles((theme) => ({
    root: {
        marginBlock: "20px 15px",
    },
    imagesContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: "8px",
        paddingTop: "0px",
        paddingBottom: "20px",
        flexWrap: "wrap"
    },
    image: {
        width: "33%",
        height: "auto",
        objectFit: "contain",
        borderRadius: "5px",
        border: "1px solid #dbe6f1",
        transition: "border 0.3s ease",
        "&:hover": {
            cursor: "pointer",
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)"
        },
        "@media (max-width: 680px)": {
            width: "100%",
            marginBottom: "12px"
        }
    }
}));


const goGoLink = (link) => {
    window.open(link, '_blank');
}

function Certificate() {
    const classes = useStyle();

    return (
        <div className={classes.root}>
            <Container maxWidth="lg">
                {/* <center><h2 style={{marginTop: "25px"}}>Certificates</h2></center> */}
                <Typography variant="h2" style={{marginBlock: "40px", textAlign: "center"}}>
                    <span style={{color: "#1882FF"}}>ST Pay</span>{" "}Certificates
                </Typography>
                <div className={classes.imagesContainer}>
                    <img src={pspImage} alt="PSP" title="PSP" id="cert-psp" onClick={()=>goGoLink("https://www.bb.org.bd/en/index.php/financialactivity/paysystems#pspo")} className={classes.image} />
                    <img src={pciDssImage} alt="PCI-DSS" title="PCI-DSS" id="cert-dss" className={classes.image} />
                    <img src={isoImage} alt="ISO" title="ISO" id="cert-iso" className={classes.image} />
                </div>
            </Container>
        </div>
    );
}

export default Certificate;
